<template>
  <div
    class="mdw-bg-white mdw-shadow-lg mdw-rounded-lg mdw-p-4 mdw-flex mdw-items-center mdw-gap-2 mdw-min-w-[300px]"
    :class="{
      'mdw-border-l-4 mdw-border-green-500': type === 'success',
      'mdw-border-l-4 mdw-border-red-500': type === 'error',
      'mdw-border-l-4 mdw-border-yellow-500': type === 'warning',
      'mdw-border-l-4 mdw-border-blue-500': type === 'info',
    }"
  >
    <div class="mdw-flex mdw-items-center mdw-gap-2">
      <i
        class="fa-solid"
        :class="{
          'fa-check-circle mdw-text-green-500': type === 'success',
          'fa-times-circle mdw-text-red-500': type === 'error',
          'fa-exclamation-circle mdw-text-yellow-500': type === 'warning',
          'fa-info-circle mdw-text-blue-500': type === 'info',
        }"
      ></i>
      <span class="mdw-text-gray-700">{{ message }}</span>
      <button
        @click="$emit('close')"
        class="mdw-text-gray-400 hover:mdw-text-gray-600 mdw-ml-4"
      >
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}>();

defineEmits(['close']);

</script>

<style>
.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-leave-active {
  position: absolute;
}
</style>